export const RECENT_SEARCH_FILTER_KEY = 'recent-search-filter';

export const SEARCHBAR_TOKENS_KEY = 'searchbar-tokens';

export const SAVED_MORTGAGE_CALCULATION_KEY = 'saved-mortgage-calculation';

export enum AdditionalSuggestionKind {
    History = 'LOCATION',
    Keyword = 'KEYWORD',
    QuickLabel = 'QUICK_LABEL'
}
